export enum ConnectionResult {
  VALID_LOGIN,
  INVALID_LOGIN,
  CANT_READ,
  NO_ATTEMPT,
}
